fx.ns("desktop.player", class Main extends shared.BaseMain {

	constructor() {
		super(new repositories.BookRepository(false, false));
		
		this.views = ["desktop.player.BookPreview","desktop.player.Splashscreen"];
		
        this.switchEffect = "hslidein";

		fx.set("app", "player");       
	}

    get creationid()
	{
		return fx.browser.urlPathParts[1];
	}

	onDataEvent(e) 
    {
		super.onDataEvent(e);

		switch (e.type) 
        {
			case "start":
                this.model.loadPreview();
				this.switchTo("Splashscreen");	
				break;

			case "creation-loaded":
				this.switchTo("BookPreview");
				break;
		}

	}

    // we leave any way in player
    onLeave(e)
	{
	}
});
